if( jQuery(".csv-display").length > 0) {
  jQuery(function(){
    if(jQuery(".dol-table").hasClass("datatabletype")) {
      jQuery(".datatabletype").DataTable();
      jQuery(".datatabletype").attr("id", "enhanced-table");
    }
  });
  var data;
  var dataFiles = [];
  var tableCaption;
  var csvData = drupalSettings.opaThemeComputedData;
  if(drupalSettings.mapDataTableCaptionData) {
    tableCaption = drupalSettings.mapDataTableCaptionData;
  }
  for (var key in csvData) {
    dataFiles.push(key);
  }
  var dataFilesRev = dataFiles.reverse();
    jQuery(".csv-display").each(function(i) {
      var csvElement = jQuery(this);
      var singleFile = dataFilesRev[i];

      jQuery.ajax({
        type: "GET",
        url: singleFile,
        dataType: "text",
        success: function(response) {
          if (typeof jQuery.csv != 'undefined') {
            data = jQuery.csv.toArrays(response);
            generateHtmlTable(data);
            createBasicWhdDropdown(data);
          } else {
            var checker = setInterval(checkCsv, 100);
            function checkCsv() {
              if (typeof jQuery.csv === 'object') {
                clearTimeout(checker);
                data = jQuery.csv.toArrays(response);
                generateHtmlTable(data);
                createBasicWhdDropdown(data);
              }
            }
          }
        }
      });


      function generateHtmlTable(data, i) {
        var html = "<table class=\"table tablesaw tablesaw-stack table-condensed table-hover table-striped\">";
        if(tableCaption ) {
          html += "<caption class='usa-sr-only'>" + tableCaption + "</caption>";
        }
        if (typeof (data[0]) == 'undefined') {
          return null;
        } else {
          jQuery.each(data, function( i, row ) {
            //bind header
            if (i == 0) {
              html += "<thead>";
              html += "<tr>";
              jQuery.each(row, function( i, colData ) {
                html += "<th scope='col'>";
                html += colData;
                html += "</th>";
              });
              html += "</tr>";
              html += "</thead>";
              html += "<tbody>";
            } else {
              html += "<tr>";
              jQuery.each(row, function( i, colData ) {
                if (i == 0) {
                  colData = generateStateRowId(colData);
                }
                html += "<td>";
                html += colData;
                html += "</td>";
              });
              html += "</tr>";
            }
          });
          html += "</tbody>";
          html += "</table>";

          jQuery(csvElement).append(html);

          var csvTable = jQuery(csvElement).find("table");
          var attachedToMap = jQuery('.field--name-field-map-data').parents('.paragraph--type--whd-map').length === 1;
          if (typeof jQuery(csvTable).DataTable === 'function') {
            jQuery(csvTable).DataTable({
              "paging": !attachedToMap
            });
          } else {
            var dataChecker = setInterval(checkDataTable, 100);
            function checkDataTable() {
              if (typeof jQuery(csvTable).DataTable === 'function') {
                clearTimeout(dataChecker);
                jQuery(csvTable).DataTable({
                  "paging": !attachedToMap
                });
              }
            }
          }
        }
      }

    });

  var stateDict = {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CNMI: 'CNMI',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  };


  function generateStateRowId(state) {
    Object.keys(stateDict).forEach(function(key) {
      var regexState = new RegExp(stateDict[key], "g");
      var regexSearchResult = state.search(regexState);

      if (regexSearchResult > -1) {
        state = '<p id="' + key + '"><strong>' + state + '</strong></p>';
      }

    });
    return state;
  }


  function showMapLocation(event, label) {
    if (label != '') {
      var stateNoSpaces = stateDict[label.toUpperCase()].split(' ').join('');
      if (jQuery('#' + label.toUpperCase())['0'] !== null) {
        window.location.hash = label.toUpperCase();
      } else {
        window.location.hash = stateNoSpaces;
      }
    } else {
      window.location.hash = '';
    }
  }

  function createBasicWhdDropdown(showStates) {
    var anotherSelectBox = "";
    var stateList = showStates.reduce(function (acc, val, index) {
        if (index) {
          acc.push(val[0]);
        }
        return acc;
    },[]);

    var selectStart = '<select id="selectState" class="usa-select" name="selectState" aria-label="Select State" onchange="showMapLocation(event, this.options[this.selectedIndex].value)">';
    var defaultValue = '<option value="">-- Select a State --</option>';
    anotherSelectBox += selectStart + defaultValue;

    var options = "";
    var stateListString = stateList.toString();
    for (var state in stateDict) {
      var regexState = new RegExp(stateDict[state], "gi");
      if ((stateListString.search(regexState))+1) {
        options += '<option value="' + state + '">' + stateDict[state] + '</option>';
      }
    }
    anotherSelectBox += options + "</select>";
    if (jQuery("#map-select").length > 0) {
      jQuery("#map-select")['0'].innerHTML = anotherSelectBox;
    }
  }
}
